import { useTranslation } from "@sagot/i18n";
import { cn, Icon } from "@sagot/ui";
import { useBillingConfig } from "../shared";
import { anyTestMode } from "./billing-model";

/**
 * "Test mode — no real money is charged." for a gateway running against its sandbox (DEC-065).
 * Status is icon + text, never colour alone. Renders nothing for live and mock gateways.
 */
export function TestModeNotice({ gateways, className }: { gateways: readonly (string | null | undefined)[]; className?: string }) {
  const { t } = useTranslation();
  const config = useBillingConfig();
  if (!anyTestMode(config.data, gateways)) return null;
  return (
    <p className={cn("flex items-center gap-2 rounded-md bg-accent-soft px-3 py-2 text-xs font-semibold text-accent-ink", className)} role="status" data-testid="test-mode-notice">
      <Icon name="flask" />
      {t("billing.gateway.testMode")}
    </p>
  );
}
